export default "__VITE_ASSET__BEapJfiz__"